import type { ErrorEvent } from '@sentry/react'

// Chrome/V8: "Cannot read properties of undefined (reading 'token_onboarding')"
//            "Cannot read property 'map' of undefined"
// Safari/WebKit: "undefined is not an object (evaluating 'r.content.token_onboarding')"
const PROPERTY_ACCESS_CRASH_PATTERNS: RegExp[] = [
  /^Cannot read propert(?:y|ies) of (?:undefined|null) \(reading '.*'\)/,
  /^undefined is not an object \(evaluating '.*'\)/,
]

const REFRESH_TOKEN_URL_FRAGMENTS = ['token/refresh', '/refresh/']
const BREADCRUMB_LOOKBACK = 5

function isPropertyAccessCrash(event: ErrorEvent): boolean {
  const values = event.exception?.values ?? []
  return values.some(
    (exception) =>
      typeof exception.value === 'string' &&
      PROPERTY_ACCESS_CRASH_PATTERNS.some((pattern) => pattern.test(exception.value as string))
  )
}

function hasRecentFailedRefreshBreadcrumb(event: ErrorEvent): boolean {
  const breadcrumbs = event.breadcrumbs ?? []
  const recent = breadcrumbs.slice(-BREADCRUMB_LOOKBACK)

  return recent.some((crumb) => {
    if (crumb.category !== 'xhr') return false
    const url = crumb.data?.url
    const statusCode = crumb.data?.status_code
    if (typeof url !== 'string') return false
    return REFRESH_TOKEN_URL_FRAGMENTS.some((fragment) => url.includes(fragment)) && statusCode === 401
  })
}

// Sessão expirou (access + refresh mortos): o interceptor de api.ts já
// redireciona pro login sozinho. Isso só filtra o crash que sobra em cima
// de chamadas que estavam em voo nesse instante, pra não afogar erros reais.
export function isSessionExpiryNoise(event: ErrorEvent): boolean {
  return isPropertyAccessCrash(event) && hasRecentFailedRefreshBreadcrumb(event)
}
